import { ToWords } from 'to-words';

export const rowPerPage = 50;
export const antTableScroll = { x: true };
export const addFormType = "Add";
export const editFormType = "Edit";

export const transactionTypeList = [
  { id: "All", title: "Select All" },
  { id: "0", title: "Pending" },
  { id: "1", title: "Success" },
  { id: "2", title: "Failed" },
  { id: "3", title: "Refund" },
];

export const baseB4Key = "data:image/jpeg;base64,";

export const getTodayDate = () => {
  // Create a new Date object for the current time
  // const now = new Date();
  // // Adjust the time for IST (+05:30)
  // const istOffset = 5.5 * 60; // IST offset in minutes
  // const localOffset = now.getTimezoneOffset(); // Local timezone offset in minutes
  // const offsetInMinutes = istOffset - localOffset;
  // now.setMinutes(now.getMinutes() + offsetInMinutes);
  // const date = now.toISOString().split("T")[0];

  const date = new Date().toISOString().split("T")[0];
  return date;
};

export const noImage = "../assets/images/no-image.jpg";
export const base64Key = "data:image/jpeg;base64,";

export const convertToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => {
      resolve(fileReader.result);
    };
    fileReader.onerror = (error) => {
      reject(error);
    };
  });
};

async function handleAllImagesUpLoad(file) {
  const base64 = await convertToBase64(file);
  // console.log('base64---', base64)
  const base642 = base64.split(",");
  return base642[1];
}
export default handleAllImagesUpLoad;

export const urlForInputFile = (file) => URL.createObjectURL(file);

export function splitImageBaseData(data) {
  const base642 = data.split(",");
  return base642[1];
}

export const templateDefault = "DEFAULT";
export const templateOne = "TEMPLATE1";
export const templateTwo = "TEMPLATE2";
export const templateThree = "TEMPLATE3";

export const defaultSiteLogo = "assets/images/logo.png";
export const defaultSiteName = "Shree Shyam Pay Pvt Ltd";
export const defaultSiteAddress =
  "3772/19 REGHAR PURA KAROL BAGH NEW DELHI - 110005 Near vishnu mandir";
// export const defaultSiteContact = "9205844811,9205844822,9205844833";
export const defaultSiteContact = "7383838717,7532812481,9311334717,8130335817";
export const defaultSiteMail = "info@sspay.com";
export const defaultSiteColor = "#fff";
export const defaultMenuColor = "#0a165e";
export const defaultButtonColor = "#9e2a96";
export const defaultDashboardMenuColor = "#000";
export const defaultDashboardButtonColor = "#6f0d5b";

export const adminRole = 1;
export const consoleEnableKey = "CONSOLE_ENABLE";
export const appConfigKey = [
  // 'LOGIN_ENABLE',
  consoleEnableKey,
  "FUNDTRANSFER_TIME",
  "LOGIN_TIME",
  "TWO_FACTOR_AUTHENTICATE",
  "SMS_ENABLE",
  "SMS_SEND_USER_DETAILS",
  "SMS_TRANSACTION_MESSAGE",
  "SMS_RECHARGE_MESSAGE",
  "SMS_MODE_ENABLE",
  "MOBILE_NO_LOGIN",
  "UNDER_MAINTENANCE",
  "Scheduler",
  // "SchedulerBatch",
  // "LIMIT_SERVICE_SWITCH_BBPS",
  // "LIMIT_SERVICE_SWITCH_DMT",
  // "LIMIT_SERVICE_SWITCH_PAYOUT",
  // "LIMIT_SERVICE_SWITCH_RECHARGE",
];

export const popButtonDefaultIcon = (
  <i className="bi bi-question-circle-fill fs-4 me-2 text-warning" />
);
export const popButtonDefaultTitile = "Confirmation";
export const popButtonDefaultDesc = (val = "") =>
  `Are you sure to ${val || "perform this action"}.`;
export const popButtonStatusIcon = (
  <i className="bi bi-exclamation-circle-fill fs-4 me-2 text-warning" />
);
export const popButtonStatusTitile = "Change Status";
export const popButtonStatusDesc = (val = "") =>
  `Are you sure to change ${val || "this data"} status.`;
export const popButtonDeleteIcon = (
  <i className="bi bi-question-circle-fill fs-4 me-2 text-warning" />
);
export const popButtonDeleteTitile = "Delete data";
export const popButtonDeleteDesc = (val = "") =>
  `Are you sure to delete ${val || "this data"}.`;

export const ellipsisLast = (data, limit = 1, fromWhere = "last") => {
  if (data && data.length > limit) {
    if (fromWhere === "last") {
      return `${data.substring(0, limit)}...`;
    }
    if (fromWhere === "start") {
      return `...${data.substring(data.length - limit, limit)}`;
    }
  }
  return data;
};

export const ellipsisButtonTitle = "View More";

export const userRoleList = {
  1: "Admin",
  2: "Employee",
  3: "Master Distributor",
  4: "Super Distributor",
  5: "Distributor",
  6: "Retailer",
};
export const allTrnxType = [0, -1, 1, 2, 3]
export const ticketTypeKey = "TICKETTYPE";
export const ticketCategoryKey = "TICKETCATEGORY";
export const ticketSubjectKey = "TICKETSUBJECT";
export const ticketProjectKey = "TICKETPROJECT";
export const byMeKey = "By Me";

export const ticketStatusList = [
  { id: 0, value: 0, title: "Pending", label: "Pending" },
  { id: 1, value: 1, title: "Resolved", label: "Resolved" },
  { id: 2, value: 2, title: "InProgress", label: "InProgress" },
  { id: 3, value: 3, title: "Hold", label: "Hold" },
  { id: 4, value: 4, title: "Reject", label: "Reject" },
  { id: 5, value: 5, title: "In Client Review", label: "In Client Review" },
  // {id: 5, title: 'Cancel'},
];

export const apiDocKeysList = [
  "APIDOC_RechargeAccess",
  "APIDOC_BillPayAccess",
  "APIDOC_PayoutAccess",
  "APIDOC_UPIPayoutAccess",
  "APIDOC_CreditCard",
  // "APIDOC_PayIn",
];

export const ConvertToIndianRupessFormat = (val) => {
  const parts = parseFloat(val).toFixed(2).split(".");
  let integerPart = parts[0];

  // Handle Indian-style commas
  const lastThree = integerPart.slice(-3);
  const otherDigits = integerPart.slice(0, -3);

  if (otherDigits !== "") {
    integerPart =
      otherDigits.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + "," + lastThree;
  }

  return integerPart + "." + parts[1];
};

export const oldNumberToWordsInRupees = (number) => {
  const units = [
    "",
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
    "Nine",
  ];
  const teens = [
    "Ten",
    "Eleven",
    "Twelve",
    "Thirteen",
    "Fourteen",
    "Fifteen",
    "Sixteen",
    "Seventeen",
    "Eighteen",
    "Nineteen",
  ];
  const tens = [
    "",
    "",
    "Twenty",
    "Thirty",
    "Forty",
    "Fifty",
    "Sixty",
    "Seventy",
    "Eighty",
    "Ninety",
  ];
  const thousands = ["", "Thousand", "Lakh", "Crore"];
  const convertChunk = (num) => {
    if (num === 0) {
      return "";
    }
    if (num < 10) {
      return units[num];
    }
    if (num < 20) {
      return teens[num - 10];
    }
    if (num < 100) {
      return `${tens[Math.floor(num / 10)]} ${convertChunk(num % 10)}`;
    }
    return `${units[Math.floor(num / 100)]} Hundred ${convertChunk(
      num % 100
    )}`;
  };

  if (number === 0) {
    return "Zero Rupees";
  }
  let words = "";
  let chunkIndex = 0;
  while (number > 0) {
    const chunk = number % 1000;
    if (chunk !== 0) {
      words = `${convertChunk(chunk)} ${thousands[chunkIndex]} ${words}`;
    }
    number = Math.floor(number / 1000);
    chunkIndex++;
  }
  // return `${words.trim()} Rupees`;
  return `${words.trim()} Rs Only`;
};



